import React, { useState, useEffect } from 'react';
const API = process.env.REACT_APP_API_URL || 'https://lacasadelpuro-pos-production.up.railway.app';
const GOLD = '#C9A84C'; const BORDER = '#2A2A2A'; const TEXT = '#E8E0D0';

export default function Receiving({ staff, hideHeader }) {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [qty, setQty] = useState(1);
  const [cost, setCost] = useState('');
  const [vendor, setVendor] = useState('');
  const [notes, setNotes] = useState('');
  const [unit, setUnit] = useState('single');
  const [log, setLog] = useState([]);
  const [msg, setMsg] = useState('');

  useEffect(() => { loadItems(); loadLog(); }, []);

  const loadItems = async () => {
    const data = await fetch(API + '/items').then(r => r.json());
    setItems(Array.isArray(data) ? data : data.items || []);
  };

  const loadLog = async () => {
    try {
      const data = await fetch(API + '/items/receiving-log').then(r => r.json());
      setLog(Array.isArray(data) ? data.slice(0, 50) : []);
    } catch(e) {}
  };

  const receive = async () => {
    if (!selected) return;
    const body = { quantity: qty, cost_per_unit: cost, vendor, notes };
    if (selected.is_cigar) body.unit = unit;
    try {
      await fetch(`${API}/items/${selected.id}/receive`, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify(body),
      });
      setMsg(`Received ${qty} × ${selected.name}${selected.is_cigar ? ' (' + unit + ')' : ''}`);
      setSelected(null); setQty(1); setCost(''); setVendor(''); setNotes(''); setUnit('single');
      loadItems(); loadLog();
      setTimeout(() => setMsg(''), 3000);
    } catch(e) { setMsg('Error: ' + e.message); }
  };

  const filtered = items
    .filter(i => i.name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      const ca = a.category_name || '\uFFFF';
      const cb = b.category_name || '\uFFFF';
      if (ca !== cb) return ca.localeCompare(cb);
      return (a.name || '').localeCompare(b.name || '');
    });

  return (
    <div style={{ padding: 20, color: TEXT, fontFamily: 'Georgia' }}>
      {!hideHeader && <h1 style={{ color: GOLD, marginBottom: 20, fontSize: 22, fontWeight: 400 }}>Receive Shipment</h1>}
      {msg && <div style={{ background: '#1A3A1A', border: '1px solid #4CAF50', borderRadius: 8, padding: '10px 16px', marginBottom: 16, color: '#4CAF50', fontSize: 13 }}>{msg}</div>}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <div>
          <div style={{ color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>Search Items</div>
          <div style={{ position: 'relative', marginBottom: 8 }}>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..."
              style={{ width: '100%', background: '#111', border: `1px solid ${BORDER}`, borderRadius: 8, padding: '10px 40px 10px 12px', color: TEXT, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
            {search && (
              <button
                type="button"
                onClick={() => setSearch('')}
                aria-label="Clear search"
                style={{
                  position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                  width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: 'transparent', border: 'none', borderRadius: 6,
                  color: '#C9A84C', fontSize: 20, lineHeight: 1, cursor: 'pointer', padding: 0,
                }}
              >×</button>
            )}
          </div>
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {filtered.map(item => (
              <div key={item.id} onClick={() => { setSelected(item); setUnit('single'); }} style={{
                padding: '10px 12px', borderRadius: 8, cursor: 'pointer', marginBottom: 4,
                background: selected?.id === item.id ? '#2A2A2A' : 'transparent',
                border: `1px solid ${selected?.id === item.id ? GOLD : 'transparent'}`,
              }}>
                <div style={{ fontSize: 13 }}>{item.name}</div>
                <div style={{ fontSize: 11, color: '#888' }}>
                  {item.is_cigar
                    ? `${item.stock_singles || 0} singles · ${item.stock_boxes || 0} boxes`
                    : `Stock: ${item.stock_count}`}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div style={{ color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>Receive Details</div>
          {selected ? (
            <div style={{ background: '#1A1A1A', border: `1px solid ${BORDER}`, borderRadius: 10, padding: 16 }}>
              <div style={{ color: GOLD, marginBottom: 12, fontSize: 14 }}>{selected.name}</div>
              {selected.is_cigar && (
                <div style={{ marginBottom: 12 }}>
                  <div style={{ color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 4 }}>Unit</div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {['single', 'box'].map(u => (
                      <button key={u} type="button" onClick={() => setUnit(u)} style={{
                        flex: 1, padding: '10px 0', borderRadius: 8,
                        background: unit === u ? GOLD : '#111',
                        color: unit === u ? '#000' : TEXT,
                        border: `1px solid ${unit === u ? GOLD : BORDER}`,
                        cursor: 'pointer', fontSize: 13, fontWeight: unit === u ? 'bold' : 'normal',
                        fontFamily: 'Georgia',
                      }}>{u.charAt(0).toUpperCase() + u.slice(1)}</button>
                    ))}
                  </div>
                </div>
              )}
              {[['Quantity', qty, setQty, 'number'], ['Cost/Unit ($)', cost, setCost, 'number'], ['Vendor', vendor, setVendor, 'text'], ['Notes', notes, setNotes, 'text']].map(([label, val, setter, type]) => (
                <div key={label} style={{ marginBottom: 12 }}>
                  <div style={{ color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
                  <input type={type} value={val} onChange={e => setter(type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value)}
                    style={{ width: '100%', background: '#111', border: `1px solid ${BORDER}`, borderRadius: 8, padding: '8px 12px', color: TEXT, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
                </div>
              ))}
              <button onClick={receive} style={{ width: '100%', background: GOLD, border: 'none', borderRadius: 8, color: '#000', padding: '12px 0', cursor: 'pointer', fontSize: 14, fontWeight: 'bold', fontFamily: 'Georgia' }}>
                Receive Shipment
              </button>
            </div>
          ) : <div style={{ color: '#444', padding: 20, textAlign: 'center' }}>Select an item to receive</div>}
        </div>
      </div>
      {log.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <div style={{ color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 12 }}>Recent Receiving Log</div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr>{['Item','Qty','Cost','Vendor','Date'].map(h => <th key={h} style={{ textAlign: 'left', padding: '8px 12px', borderBottom: `1px solid ${BORDER}`, color: '#888', fontSize: 10, letterSpacing: 1, textTransform: 'uppercase' }}>{h}</th>)}</tr></thead>
            <tbody>{log.map((r, i) => <tr key={i}><td style={{ padding: '8px 12px', fontSize: 12, borderBottom: '1px solid #1E1E1E' }}>{r.item_name}</td><td style={{ padding: '8px 12px', fontSize: 12, borderBottom: '1px solid #1E1E1E' }}>{r.quantity}</td><td style={{ padding: '8px 12px', fontSize: 12, borderBottom: '1px solid #1E1E1E' }}>${r.cost_per_unit||'—'}</td><td style={{ padding: '8px 12px', fontSize: 12, borderBottom: '1px solid #1E1E1E' }}>{r.vendor||'—'}</td><td style={{ padding: '8px 12px', fontSize: 12, borderBottom: '1px solid #1E1E1E', color: '#666' }}>{r.received_at ? new Date(r.received_at).toLocaleDateString() : '—'}</td></tr>)}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
